import { Box, Grid, List, ListItem, Typography } from '@mui/material';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { Image } from 'primereact/image';
import { Toast } from 'primereact/toast';
import React, { useEffect, useId, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import getRequest, { postRequest, putRequest } from '../../../assets/helper/ApiHandler';
import { regexPatterns } from '../../../assets/helper/RegexPattern';
import { auctionTypeOptions, budgetPacingOptions, demandTypeOptions, endpointDataCenterLocationOptions, impressionsOptions } from '../../constantObject/Options';
import { v4 as uuidv4 } from 'uuid';
import { admixerSchema, azerionSchema, bidmachineSchema, braveSchema, colossusSchema, epsilonSchema, freewheelSchema, inmobiSchema, loopmeSchema, medianetSchema, onetagSchema, ortbwsSchema, placeexchangeSchema, pubmaticSchema, pulsePointSchema, rubiconSchema, smartadserverSchema, sonobiSchema, sovrnSchema, tripleliftSchema, unrulySchema, vistarSchema, xandrSchema } from '../test_schema/Schema';
import { convertArrayToJson, convertJsonToList, isValidJson } from '../../../assets/helper/helper';
import AddIcon from '../../../assets/images/icons/add.svg';

var demandObject = {
    name: '',
    endPoint: '',
    endpointDatacenterLocation: '',
    domain: '',
    demandPartner: '',
    demandDescription: '',
    demandSetting: null,
    qps: '',
    margin: '',
    rCompression: true,
    serviceFee: '',
    maxSchainNodes: '',
    impressionType: '',
    minTmaxRequired: '',
    maxBidFloor: '',
    minBidFloor: '',
    auctionType: '',
    dailyBudget: '',
    totalBudget: '',
    type: '',
    dailyBudgetPacing: null,
    isEnabled: false,

}

var formTouchedObj = {
    name: false,
    endPoint: false,
    domain: false,
    demandPartner: false,
    qps: false,
    margin: false,
    type: false,
    serviceFee: false,
    maxSchainNodes: false,
}
const values = [
    { id: 1, text: "Basic Information", path: "basic-information" },
    { id: 2, text: "Description", path: "description" },
    { id: 3, text: "Preferences", path: "preferences" },
    { id: 4, text: "Additional Configuration", path: "additional-configuration" },
    { id: 5, text: "Budget", path: "budget" }
];


export function Demand(props) {
    const [dailyBudgetPacing, setDailyBudgetPacing] = useState(null);
    const [auctionType, setAuctionType] = useState(null);
    const [demandType, setDemandType] = useState(null);
    const [demand, setDemand] = useState(demandObject);
    const [demandPartners, setDemandPartners] = useState([]);
    const [formTouched, setFormTouched] = useState(formTouchedObj);
    const [demandFormError, setDemandFormError] = useState(demandObject)
    const [title, setTitle] = useState('Create');
    const [active, setActive] = useState();
    const params = useParams();
    const navigate = useNavigate();
    const toast = useRef(null)
    const [selectedDemandPartners, setSelectedDemandPartners] = useState(null);
    const [impressionType, setImpressionType] = useState(null);
    const [endpointDataCenterLocation, setEndpointDataCenterLocation] = useState(null);
    const formMode = params.id ? 'Edit' : "Create";
    const isEditMode = params.id ? true : false;
    const [showForm, setShowForm] = useState(false);
    const [demandSettings, setDemandSettings] = useState([]);


    useEffect(() => {
        if (demandType !== demand.type) {
            setDemand(prevDemand => ({
                ...prevDemand,
                demandSetting: null
            }));
        }
    }, [demandType]);

    useEffect(() => {
        let dem = {
            ...demand,
            serviceFee: 0,
            margin: 0
        }
        setDemand(dem);
    }, [])

    useEffect(() => {
        getDemandPartners();
        if (params.id) {
            getDemand();
        }
    }, [params.id]);

    useEffect(() => {
        if (Object.values(formTouched).some((touched) => touched === true)) {
            validateFormData();
        }
    }, [demand, formTouched]);

    const handleInputChange = (e) => {
        const { id, value } = e.target;
        setDemand({
            ...demand,
            [id]: value
        });
        setFormTouched({
            ...formTouched,
            [id]: true,
        });
    };

    const handleFormData = (formData) => {
        setDemand({
            ...demand,
            demandSetting: formData
        });
    };
    const handleEditClick = (isShown) => {
        setShowForm(isShown);
    };

    const handleCloseForm = () => {
        setShowForm(false);
    };

    const handleDemandPartnerChange = (e) => {
        const selectedPartner = e.value;
        setDemand({
            ...demand,
            demandPartner: selectedPartner
        });

        setFormTouched({
            ...formTouched,
            demandPartner: true,
        });
    };


    const getDemand = async () => {
        try {
            const demandData = await getRequest(`/demands/${params.id}`);
            const initializedDemand = {
                ...demandObject,
                ...demandData
            };
            setDemand(initializedDemand);
            setDemandSettings(convertJsonToList(initializedDemand.demandSetting))
            setDailyBudgetPacing(demandData.dailyBudgetPacing);
            setImpressionType(demandData.impType)
            setAuctionType(demandData.auctionType)
            setDemandType(demandData.type)
            setSelectedDemandPartners(demandData.demandPartner)
            setEndpointDataCenterLocation(demandData.endpointDatacenterLocation)
        } catch (error) {
            if (toast.current) {
                toast.current.show({ severity: "error", summary: 'Error', detail: error });
            }
        }
    };


    const getDemandPartners = async () => {
        try {
            const demandData = await getRequest(`/demand-partners`);
            setDemandPartners(demandData)
        } catch (error) {
            if (toast.current) {
                toast.current.show({ severity: "error", summary: 'Error', detail: error });
            }
        }
    };


    const handleCancel = () => {
        navigate('/demand');
    };

    const handleOnSubmit = () => {
        if (validateFormData()) {
            const payload = {
                ...demand, dailyBudgetPacing: dailyBudgetPacing,
                impType: impressionType,
                auctionType: auctionType,
                type: demandType, endpointDatacenterLocation: endpointDataCenterLocation,
                demandSetting: convertArrayToJson(demandSettings)
            };

            if (isEditMode) {
                updateDemand(payload);
            } else {
                saveDemand(payload);
            }
        }
        else {
            if (toast.current) {
                toast.current.show({ severity: "error", summary: 'Error', detail: "Check all required field " });
            }
        }
    };

    const saveDemand = async (payload) => {
        try {
            let res = await postRequest('/demands', payload, navigate);
            if (toast.current) {
                toast.current.show({ severity: "success", summary: 'Success', detail: "Demand  Created! " });
            }
            setTimeout(() => { navigate('/demand') }, 1000);
        } catch (error) {
            if (toast.current) {
                toast.current.show({ severity: "error", summary: 'Error', detail: error });
            }
        }
    }

    const updateDemand = async (payload) => {
        try {
            let res = await putRequest(`/demands/${params.id}`, payload, navigate);
            if (toast.current) {
                toast.current.show({ severity: "success", summary: 'Success', detail: "Demand  updated! " });
            }
            setTimeout(() => { navigate('/demand') }, 1000);
        } catch (error) {
            if (toast.current) {
                toast.current.show({ severity: "error", summary: 'Error', detail: error });
            }
        }
    }


    const validateFormData = () => {
        let errors = {};
        let flag = false;

        if (!demand.name) {
            errors.name = 'Demand is required!';
        }
        if (!demand.demandPartner) {
            errors.demandPartner = "Demand partner name is required!"
        }
        if (!demandType) {
            errors.type = "Demand vendor name is required!"
        }
        if (!demand.endPoint) {
            errors.endPoint = 'Endpoint is required!';
        }
        if (!demand.domain) {
            if (!regexPatterns.domain.test(demand.domain)) {
                errors.domain = 'Domain is required!';
            }
        }
        if (!demand.qps) {
            errors.qps = 'QPS is required!';
        }
        if (demand.margin === '' || demand.margin < -50 || demand.margin > 99) {
            errors.margin = 'Margin  is required! & must be between -50 and 99 ';
        }
        if (demand.serviceFee === '' || demand.serviceFee < 0 || demand.serviceFee > 99) {
            errors.serviceFee = 'Service Fee Required &  must be between 0 and 99!';
        }
        if (!demand.maxSchainNodes || demand.maxSchainNodes < 0 || demand.maxSchainNodes > 20) {
            errors.maxSchainNodes = 'MaxSchainNodes  is required & must be between 0 to 20 ';
        }

        if (demand.dailyBudget && demand.totalBudget) {
            const dailyBudget = parseFloat(demand.dailyBudget);
            const totalBudget = parseFloat(demand.totalBudget);
            if (dailyBudget > totalBudget) {
                errors = {
                    ...errors,
                    dailyBudget: 'Daily budget cannot be greater than total budget!',
                    totalBudget: 'Total budget cannot be less than daily budget!'
                };
            }
        }
        setDemandFormError(errors);
        if (Object.keys(errors).length === 0) {
            flag = true;
        }
        return flag;
    };


    const handleDemandSettingValues = (e, item) => {
        let list = [...demandSettings];
        switch (e.target.id) {
            case "key":
                for (let i = 0; i < list.length; i++) {
                    if (list[i].id === item.id) {
                        list[i].key = e.target.value;
                        break;
                    }
                }
                break;
            case "value":
                for (let i = 0; i < list.length; i++) {
                    if (list[i].id === item.id) {
                        list[i].value = e.target.value;
                        break;
                    }
                }

            default:
                break;
        }
        setDemandSettings(list);
    }

    const addnewRowToDemandSettings = () => {
        let list = [...demandSettings];
        list.push({ id: uuidv4(), key: "", value: "" })
        setDemandSettings(list);
    }

    const handleOnChangeDemandType = (e) => {
        const value = e.value;
        let json = getJsonByDemandType(value);
        setDemandSettings(convertJsonToList(json));
        setDemandType(value);
        setFormTouched(prev => ({ ...prev, type: true }));
    };
    const getJsonByDemandType = (demandType) => {
        let selectedSchema;
        switch (demandType) {
            case 'xandr':
                selectedSchema = xandrSchema;
                break;
            case 'unruly':
                selectedSchema = unrulySchema;
                break;
            case 'rubicon':
                selectedSchema = rubiconSchema;
                break;
            case 'loopme':
                selectedSchema = loopmeSchema;
                break;
            case 'triplelift':
                selectedSchema = tripleliftSchema
                break;
            case 'pubmatic':
                selectedSchema = pubmaticSchema;
                break;
            case 'bidswitch':
                break;
            case 'epsilon':
                selectedSchema = epsilonSchema;
                break;
            case 'smartadserver':
                selectedSchema = smartadserverSchema;
                break;
            case 'INMOBI':
                selectedSchema = inmobiSchema;
                break;
            case 'PULSEPOINT':
                selectedSchema = pulsePointSchema;
                break;
            case 'BIDMACHINE':
                selectedSchema = bidmachineSchema;
                break;
            case 'AZERION':
                selectedSchema = azerionSchema;
                break;
            case 'ONETAG':
                selectedSchema = onetagSchema;
                break;
            case 'MEDIANET':
                selectedSchema = medianetSchema;
                break;
            case 'SONOBI':
                selectedSchema = sonobiSchema;
                break;
            case 'BRAVE':
                selectedSchema = braveSchema;
                break;
            case 'SOVRN':
                selectedSchema = sovrnSchema;
                break;
            case 'ADMIXER':
                selectedSchema = admixerSchema;
                break;
            case 'Colossus':
                selectedSchema = colossusSchema;
                break;
            case 'VISTAR':
                selectedSchema = vistarSchema;
                break;
            case 'PLACEEXCHANGE':
                selectedSchema = placeexchangeSchema;
                break;
            case 'ortbws':
                selectedSchema = ortbwsSchema;
                break;
            case 'FREEWHEEL':
                selectedSchema = freewheelSchema;
                break;
            default:
                alert('Please select a demand type first');
                break;
        }
        return selectedSchema;
    }

    let { name: demandName, endPoint, demandOperationalDomain, dema, demandDescription, bundleSpecificSettings, qps, margin, rComparison,
        serviceFee,
        maxSchainNodes,
    } = demand;

    const removeDemandSetting = (id) => {
        setDemandSettings(demandSettings.filter(item => item.id !== id));
    };

    return (
        <div>
            <Toast ref={toast} position="bottom-right"></Toast>
            <Box className='main-content-header header-bottom-line'>
                <h2>{formMode + " Demand"}</h2>
            </Box>
            <Box>
                <Grid container spacing={2}>
                    <Grid item xs={3}>
                        <Box className='content-sticky-top'>
                            <List className='list-page-link'>
                                {values.map((val) => (
                                    <ListItem key={val.id} className='fs-2' onClick={() => setActive(val.id)}>
                                        <a href={'#' + val.path} style={{ textDecoration: 'none' }} className={active === val.id ? "active" : ""}>{val.text || ""}</a>
                                    </ListItem>
                                ))}
                            </List>
                        </Box>
                    </Grid>
                    <Grid item xs={9} sx={{ gap: 1, flexGrow: 1, overflow: 'hidden auto', marginTop: '1.5rem', scrollBehavior: "smooth" }} >
                        <Box className="card omega-forms">
                            <Box id="basic-information" className="basic-information-new" sx={{ minWidth: 0, flex: 1, padding: '1rem' }}>
                                <Box sx={{ minWidth: 0, flex: 1 }}>
                                    <Typography level="title-sm" className='fs-1'>Basic Information</Typography>
                                </Box>
                                <Grid container spacing={2}>
                                    <Grid item xs={4}>
                                        <Typography level="title-sm" className='fs-2'>Demand Name *</Typography>
                                        <Typography level="body-xs" className='fs-3' htmlFor="demand">Enter the name of the demand</Typography>
                                    </Grid>
                                    <Grid item xs={8}>
                                        <InputText
                                            id="name"
                                            placeholder=""
                                            type="text"
                                            className={demandFormError.name ? 'mr-2 p-invalid' : 'mr-2'}
                                            value={demand?.name ?? ''}
                                            onChange={handleInputChange}
                                        />
                                        {demandFormError.name && (
                                            <Typography level="title-sm" className="error-message fs-2">{demandFormError.name || ''}</Typography>
                                        )}
                                    </Grid>
                                </Grid>
                                <Grid container spacing={2}>
                                    <Grid item xs={4}>
                                        <Typography level="title-sm" className='fs-2'>Demand Vendor * </Typography>
                                        <Typography level="body-xs" className='fs-3'>Select the  Demand Vendor    </Typography>
                                    </Grid>
                                    <Grid item xs={8}>
                                        <Dropdown
                                            value={demandType || ''}
                                            filter
                                            className={demandFormError.type ? 'mr-2 p-invalid' : 'mr-2'}
                                            onChange={handleOnChangeDemandType}
                                            options={demandTypeOptions}
                                            optionLabel="name" />
                                        {demandFormError.type && (
                                            <Typography level="title-sm" className="error-message fs-2">{demandFormError.type || ''}</Typography>
                                        )}
                                    </Grid>
                                </Grid>
                                <Grid container spacing={2}>
                                    <Grid item xs={4}>
                                        <Typography level="title-sm" className='fs-2'>Demand Endpoint *</Typography>
                                        <Typography level="body-xs" className='fs-3'>Enter the demand endpoint</Typography>
                                    </Grid>
                                    <Grid item xs={8}>
                                        <InputText
                                            id="endPoint"
                                            type="text"
                                            placeholder=""
                                            className={demandFormError.endPoint ? 'mr-2 p-invalid' : 'mr-2'}
                                            value={demand?.endPoint ??''}
                                            onChange={handleInputChange} />
                                        {demandFormError.endPoint && (
                                            <Typography level="title-sm" className="error-message fs-2">{demandFormError.endPoint || ''}</Typography>
                                        )}
                                    </Grid>
                                </Grid>
                                <Grid container spacing={2}>
                                    <Grid item xs={4}>
                                        <Typography level="title-sm" className='fs-2'>Endpoint Datacenter Location </Typography>
                                        <Typography level="body-xs" className='fs-3'>Enter the endpoint datacenter location </Typography>
                                    </Grid>
                                    <Grid item xs={8}>
                                        <Dropdown
                                            value={endpointDataCenterLocation || ''}
                                            filter
                                            onChange={(e) => { setEndpointDataCenterLocation(e.value) }}
                                            options={endpointDataCenterLocationOptions}
                                            optionLabel="name" />
                                    </Grid>
                                </Grid>
                                <Grid container spacing={2}>
                                    <Grid item xs={4}>
                                        <Typography level="title-sm" className='fs-2'>Demand Operational Domain *</Typography>
                                        <Typography level="body-xs" className='fs-3'>Enter the demand operational domain</Typography>
                                    </Grid>
                                    <Grid item xs={8}>
                                        <InputText
                                            id="domain"
                                            type="text"
                                            value={demand?.domain ?? ''}
                                            className={demandFormError.domain ? 'mr-2 p-invalid' : 'mr-2'}
                                            onChange={handleInputChange} />
                                        {demandFormError.domain && (
                                            <Typography level="title-sm" className="error-message fs-2">{demandFormError.domain || ''}</Typography>
                                        )}
                                    </Grid>
                                </Grid>
                                <Grid container spacing={2}>
                                    <Grid item xs={4}>
                                        <Typography level="title-sm" className='fs-2'>Select Demand Partner *</Typography>
                                        <Typography level="body-xs" className='fs-3'>Select the demand partner  </Typography>
                                    </Grid>
                                    <Grid item xs={8}>
                                        <Dropdown
                                            value={demand?.demandPartner ?? ''}
                                            filter
                                            className={demandFormError.demandPartner ? 'mr-2 p-invalid' : 'mr-2'}
                                            onChange={handleDemandPartnerChange}
                                            options={demandPartners}
                                            optionLabel="demandPartnerName"
                                        />
                                        {demandFormError.demandPartner && (
                                            <Typography level="title-sm" className="error-message fs-2">{demandFormError.demandPartner || ''}</Typography>
                                        )}
                                    </Grid>
                                </Grid>
                            </Box>
                            <Box sx={{ minWidth: 0, flex: 1, padding: '1rem' }} className="form-group-border-top">
                                <Box sx={{ minWidth: 0, flex: 1 }}>
                                    <Typography id="description" level="title-sm" className='fs-1'>Description</Typography>
                                </Box>
                                <Grid container spacing={2}>
                                    <Grid item xs={4}>
                                        <Typography level="title-sm" className='fs-2'>Demand Description</Typography>
                                        <Typography level="body-xs" className='fs-3' htmlFor="demand-partner-name">Enter a description for demand </Typography>
                                    </Grid>
                                    <Grid item xs={8}>
                                        <InputText id="demandDescription"
                                            placeholder=""
                                            className="mr-2"
                                            onChange={handleInputChange}
                                            value={demandDescription ? demandDescription : ''} />
                                    </Grid>
                                </Grid>
                            </Box>
                            <Box sx={{ minWidth: 0, flex: 1, padding: '1rem' }} className="form-group-border-top form-group-border-bottom">
                                <Box sx={{ minWidh: 0, flex: 1 }}>
                                    <Typography id="preferences" level="title-sm" className='fs-1'>Preferences</Typography>
                                </Box>
                                {/* <Grid container spacing={1}>
                                    <Grid item xs={4}>
                                        <Typography level="title-sm" className='fs-2'>Demand Settings</Typography>
                                        <Typography level="body-xs" className='fs-3' htmlFor="demand">Enter the demand settings to pass in the request </Typography>
                                    </Grid>
                                    <Grid item xs={8}>
                                        <Grid sx={{ gap: 1, flexGrow: 1, display: 'flex' }}>
                                            <Dropdown
                                                placeholder='Select '
                                                value={demandSettingValue}
                                                options={demandSettings}
                                                onChange={handleDemandSettingValues}
                                                optionLabel="key"
                                                className="auto-width h-30" />
                                            <InputText id=""
                                                placeholder=""
                                                value={typeof demandSettingValue === 'object' ? JSON.stringify(demandSettingValue) : demandSettingValue}
                                                onChange={handleDemandSettingValues}
                                                className="mr-2 auto-width h-30" />
                                            <Button variant="contained" className="button-style-2 button-plus" style={{ margin: '5px 0' }}>+</Button>
                                        </Grid>

                                    </Grid>
                                </Grid> */}

                                <Grid container spacing={1}>
                                    <Grid item xs={4}>
                                        <Typography level="title-sm" className='fs-2'>Demand Settings</Typography>
                                        <Typography level="body-xs" className='fs-3' htmlFor="demand">Enter the demand settings to pass in the request </Typography>
                                    </Grid>
                                    <Grid item xs={8}>
                                        {
                                            demandSettings.map(item => {
                                                return <Grid key={item.id} sx={{ gap: 1, flexGrow: 1, display: 'flex' }} className='demand-Settings'>
                                                    <InputText
                                                        id="key"
                                                        value={item.key || ''}
                                                        onChange={(e) => handleDemandSettingValues(e, item)}
                                                        className="mr-2 auto-width h-30" />

                                                    <InputText
                                                        id="value"
                                                        value={typeof item.value === 'object' ? JSON.stringify(item.value) : (item.value || '')}
                                                        onChange={(e) => handleDemandSettingValues(e, item)}
                                                        className="mr-2 auto-width h-30" />
                                                    <Button
                                                        type="button"
                                                        className='remove-icon-btn'
                                                        onClick={() => removeDemandSetting(item.id)}>
                                                        <Image src={AddIcon} alt="Image" width="24" />
                                                    </Button>
                                                </Grid>
                                            })
                                        }
                                        <Button variant="contained" className="button-style-2 button-plus" style={{ margin: '5px 0' }}
                                            onClick={addnewRowToDemandSettings}
                                        >+</Button>
                                    </Grid>
                                </Grid>

                                <Grid container spacing={2}>
                                    <Grid item xs={4}>
                                        <Typography level="title-sm" className='fs-2'>QPS *</Typography>
                                        <Typography level="body-xs" className='fs-3' htmlFor="demand">Enter the qps of the request   </Typography>
                                    </Grid>
                                    <Grid item xs={8}>
                                        <InputText
                                            id="qps"
                                            type="number"
                                            placeholder=""
                                            className={demandFormError.qps ? 'mr-2 p-invalid' : 'mr-2'}
                                            value={demand?.qps ?? ''}
                                            onChange={handleInputChange} />
                                        {demandFormError.qps && (
                                            <Typography level="title-sm" className="error-message fs-2">{demandFormError.qps || ''}</Typography>
                                        )}
                                    </Grid>
                                </Grid>
                                <Grid container spacing={2}>
                                    <Grid item xs={4}>
                                        <Typography level="title-sm" className='fs-2'>Demand Margin *</Typography>
                                        <Typography level="body-xs" className='fs-3' htmlFor="demand">Enter the demand margin</Typography>
                                    </Grid>
                                    <Grid item xs={8}>
                                        <InputText
                                            id="margin"
                                            placeholder=""
                                            className={demandFormError.margin ? 'mr-2 p-invalid' : 'mr-2'}
                                            type="number"
                                            onChange={handleInputChange}
                                            value={demand?.margin ?? ''}
                                        />
                                        {demandFormError.margin && (
                                            <Typography level="title-sm" className="error-message fs-2">{demandFormError.margin || ''}</Typography>
                                        )}
                                    </Grid>
                                </Grid>
                                <Grid container spacing={2}>
                                    <Grid item xs={4}>
                                        <Typography level="title-sm" className='fs-2'>Request Compression</Typography>
                                        <Typography level="body-xs" className='fs-3' htmlFor="demand">Select if Request Compression if required</Typography>
                                    </Grid>
                                    <Grid item xs={8}>
                                        <Dropdown
                                            value={demand ? demand.rCompression : false}
                                            onChange={(e) => setDemand({ ...demand, rCompression: e.value === true })}
                                            options={[
                                                { name: 'Yes', value: true },
                                                { name: 'No', value: false }
                                            ]}
                                            optionLabel="name" >
                                        </Dropdown>
                                    </Grid>
                                </Grid>
                                <Grid container spacing={2}>
                                    <Grid item xs={4}>
                                        <Typography level="title-sm" className='fs-2'>Service Fee *</Typography>
                                        <Typography level="body-xs" className='fs-3' htmlFor="demand">Enter a service fee for the demand </Typography>
                                    </Grid>
                                    <Grid item xs={8}>
                                        <InputText id="serviceFee"
                                            placeholder=""
                                            className={demandFormError.serviceFee ? 'mr-2 p-invalid' : 'mr-2'}
                                            type='number'
                                            value={demand ? demand.serviceFee : 0}
                                            onChange={handleInputChange}
                                        />
                                        {demandFormError.serviceFee && (
                                            <Typography level="title-sm" className="error-message fs-2">{demandFormError.serviceFee || ''}</Typography>
                                        )}
                                    </Grid>
                                </Grid>
                                <Grid container spacing={2}>
                                    <Grid item xs={4}>
                                        <Typography level="title-sm" className='fs-2'>Max Schain Nodes Allowed *</Typography>
                                        <Typography level="body-xs" className='fs-3' htmlFor="demand">Enter max schain node to pass</Typography>
                                    </Grid>
                                    <Grid item xs={8}>
                                        <InputText
                                            id="maxSchainNodes"
                                            placeholder=""
                                            className={demandFormError.maxSchainNodes ? 'mr-2 p-invalid' : 'mr-2'}
                                            value={demand?.maxSchainNodes ?? ''}
                                            onChange={handleInputChange} />
                                        {demandFormError.maxSchainNodes && (
                                            <Typography level="title-sm" className="error-message fs-2">{demandFormError.maxSchainNodes || ''}</Typography>
                                        )}
                                    </Grid>
                                </Grid>
                                <Grid container spacing={2}>
                                    <Grid item xs={4}>
                                        <Typography level="title-sm" className='fs-2'>Impression Type </Typography>
                                        <Typography level="body-xs" className='fs-3' htmlFor="demand">Select type of impression passed in the request </Typography>
                                    </Grid>
                                    <Grid item xs={8}>
                                        <Dropdown optionLabel="name" value={impressionType} onChange={(e) => { setImpressionType(e.value) }}
                                            options={impressionsOptions}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container spacing={2}>
                                    <Grid item xs={4}>
                                        <Typography level="title-sm" className='fs-2'>Min Tmax Required </Typography>
                                        <Typography level="body-xs" className='fs-3' htmlFor="demand">Select min tmax  if required</Typography>
                                    </Grid>
                                    <Grid item xs={8}>
                                        <InputText
                                            id="minTmaxRequired"
                                            className='mr-2'
                                            type="number" value={demand?.minTmaxRequired ?? ''}
                                            onChange={handleInputChange} />
                                    </Grid>
                                </Grid>
                            </Box>
                            {/* Added here Additional Configuration */}
                            <Box sx={{ minWidth: 0, flex: 1, padding: '1rem' }} className="form-group-border-bottom">
                                <Box sx={{ minWidth: 0, flex: 1 }}>
                                    <Typography id="additional-configuration" level="title-sm" className='fs-1'>Additional Configuration </Typography>
                                </Box>
                                <Grid container spacing={2}>
                                    <Grid item xs={4}>
                                        <Typography level="title-sm" className='fs-2'>Auction Type</Typography>
                                        <Typography level="body-xs" className='fs-3' htmlFor="demand">Select the auction type  </Typography>
                                    </Grid>
                                    <Grid item xs={8}>
                                        <Dropdown value={auctionType}
                                            onChange={(e) => { setAuctionType(e.value) }}
                                            options={auctionTypeOptions}
                                            optionLabel="name" />
                                    </Grid>
                                </Grid>
                            </Box>
                            {/* added here Budget  */}
                            <Box sx={{ minWidth: 0, flex: 1, padding: '1rem' }} className="form-group-border-bottom">
                                <Box sx={{ minWidth: 0, flex: 1 }}>
                                    <Typography id="budget" level="title-sm" className='fs-1'>Budget</Typography>

                                    <Grid container spacing={2}>
                                        <Grid item xs={4}>
                                            <Typography level="title-sm" className='fs-2'>Daily Budget($) </Typography>
                                            <Typography level="body-xs" className='fs-3' htmlFor="demand">Enter the  daily budget  </Typography>
                                        </Grid>
                                        <Grid item xs={8}>
                                            <InputText
                                                id="dailyBudget"
                                                placeholder=""
                                                className="mr-2"
                                                type="number"
                                                value={demand?.dailyBudget ?? ''}
                                                onChange={handleInputChange} />
                                            {demandFormError.dailyBudget && (
                                                <Typography level="title-sm" className="error-message fs-2">{demandFormError.dailyBudget || ''}</Typography>
                                            )}
                                        </Grid>
                                    </Grid>
                                    <Grid container spacing={2}>
                                        <Grid item xs={4}>
                                            <Typography level="title-sm" className='fs-2'>Total Budget($)</Typography>
                                            <Typography level="body-xs" className='fs-3' htmlFor="demand">Enter the total budget </Typography>
                                        </Grid>
                                        <Grid item xs={8}>
                                            <InputText id="totalBudget" placeholder="" className="mr-2" type="number" value={demand?.totalBudget ?? ''} onChange={handleInputChange} />
                                            {demandFormError.totalBudget && (
                                                <Typography level="title-sm" className="error-message fs-2">{demandFormError.totalBudget || ""}</Typography>
                                            )}
                                        </Grid>
                                    </Grid>
                                    <Grid container spacing={2}>
                                        <Grid item xs={4}>
                                            <Typography level="title-sm" className='fs-2'>Daily Budget Pacing</Typography>
                                            <Typography level="body-xs" className='fs-3' htmlFor="demand">Select method of daily budget pacing</Typography>
                                        </Grid>
                                        <Grid item xs={8}>
                                            <Dropdown
                                                value={dailyBudgetPacing || ''}
                                                onChange={(e) => { setDailyBudgetPacing(e.value) }}
                                                options={budgetPacingOptions}
                                                optionLabel="name" />
                                        </Grid>
                                    </Grid>
                                </Box>
                            </Box>
                            {isEditMode && (
                                <Box id="status" sx={{ minWidth: 0, flex: 1, padding: '1rem' }} className="form-group-border-bottom">
                                    <Box sx={{ minWidth: 0, flex: 1 }}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={4}>
                                                <Typography level="title-sm" className='fs-2'>Status</Typography>
                                                <Typography level="body-xs" className='fs-3' htmlFor="demand">Select the status of the demand</Typography>
                                            </Grid>
                                            <Grid item xs={8}>
                                                <Dropdown
                                                    value={demand ? demand.isEnabled : false}
                                                    onChange={(e) => setDemand({ ...demand, isEnabled: e.value === true })}
                                                    options={[
                                                        { name: 'Active', value: true },
                                                        { name: 'Stopped', value: false }
                                                    ]}
                                                    optionLabel="name"
                                                />
                                            </Grid>
                                        </Grid>
                                    </Box>
                                </Box>
                            )}
                            <Box sx={{ minWidth: 0, display: 'flex', padding: '1rem', justifyContent: 'end' }} gap={2} className="form-footer">
                                <Button type="button" className="button-style-2" label="Cancel" size="small" onClick={handleCancel}></Button>
                                <Button type="button" className="button-style-1" label="Save" size="small" onClick={handleOnSubmit}></Button>
                            </Box>
                        </Box>
                    </Grid>
                </Grid>
            </Box>
        </div >
    );
};

export default Demand;

